import { store } from '../../App'
import { FAIL_FETCH } from './Other'
export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS'
export const FETCH_NOTIFICATION_DETAILS = 'FETCH_NOTIFICATION_DETAILS'
export const FETCH_CONTENT_DETAILS = 'FETCH_CONTENT_DETAILS'
export const FETCH_ALERT_DETAILS = 'FETCH_ALERT_DETAILS'
export const FETCH_ADMIN_DETAILS = 'FETCH_ADMIN_DETAILS'
export const LOAD_USER_DETAILS = 'LOAD_USER_DETAILS'
export const LOAD_NOTIFICATION_DETAILS = 'LOAD_NOTIFICATION_DETAILS'
export const LOAD_CONTENT_DETAILS = 'LOAD_CONTENT_DETAILS'
export const LOAD_ADMIN_DETAILS = 'LOAD_ADMIN_DETAILS'
export const FETCH_NOTIFICATION_USERS = 'FETCH_NOTIFICATION_USERSS'
export const LOAD_NOTIFICATION_USERS = 'LOAD_NOTIFICATION_USERS'
export const LOAD_ALERT_DETAILS = 'LOAD_ALERT_DETAILS'
export const RESET_NOTIFICATION_DETAILS = 'RESET_NOTIFICATION_DETAILS'

/**
  * fetchUserDetails
  * @desc generate fetch user details action generator
  * @param {string} ID accountId
  * @param {timestamp} start start Date
  * @param {timestamp} end end Date
  * @param {string} user user ID
  * @param {Object} options
  * @return {action} fetchUserDetailsActions
*/
export function fetchUserDetails (ID, start, end, user, options) {
  const query = { accountId: ID, startDate: start, endDate: end, userId: user }
  return { type: FETCH_USER_DETAILS, query }
}

/**
  * fetchNotificationDetails
  * @desc generate fetch user details action generator
  * @param {string} ID accountId
  * @param {string} type notification type
  * @param {string} notification of documentId
  * @return {action} fetchNotificationDetailsAction
*/
export function fetchNotificationDetails (ID, type, documentId) {
  const query = { accountId: ID, pushNotificationType: type, documentId }
  return { type: FETCH_NOTIFICATION_DETAILS, query }
}

/**
 * fetchPushNotifications
 * @param {string} ID accountId
 * @param {string} type notification type
 * @param {string} documentId Document ID of the notification
 * @param {Object} options fetch notification users Options
 * @return {action} fetchNotificationUsersAction
 */
export function fetchNotificationUsers (ID, type, documentId, options) {
  const query = { accountId: ID, pushNotificationType: type, documentId }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.sort) {
    query.sort = options.sort
  }
  if (options.offset) {
    query.offset = options.offset
  } else {
    query.offset = 0
  }
  return { type: FETCH_NOTIFICATION_USERS, query }
}

/**
  * fetchContentDetails
  * @desc generate a fetch content details action
  * @param {string} ID accountID
  * @param {timestamp} start start Date
  * @param {timestamp} end start Date
  * @param {string} content content ID
  * @param {Object} options fetch content Options
  * @return {action} fetchContentDetailsAction
*/
export function fetchContentDetails (ID, start, end, content, options) {
  const query = { accountId: ID, startDate: start, endDate: end, contentId: content }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.groupIds = ['AllGROUPS']
  }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  return { type: FETCH_CONTENT_DETAILS, query }
}

/**
  * fetchAlertDetails
  * @desc generate a fetch alert details action
  * @param {string} ID accountID
  * @param {timestamp} start start Date
  * @param {timestamp} end start Date
  * @param {string} alert alert ID
  * @param {Object} options fetch alert Options
  * @return {action} fetchAlertDetailsAction
*/
export function fetchAlertDetails (ID, start, end, alert, options) {
  const query = { accountId: ID, startDate: start, endDate: end, alertId: alert }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.groupIds = ['AllGROUPS']
  }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  return { type: FETCH_ALERT_DETAILS, query }
}

/**
  * fetchAdminDetails
  * @desc Fetch Admin Details Action Generator
  * @param {string} ID accountID
  * @param {timestamp} start start Date
  * @param {timestamp} end start Date
  * @param {string} content content ID
  * @param {Object} options fetch content Options
  * @return {action} fetchAdminDetailsAction
*/
export function fetchAdminDetails (ID, start, end, user, options) {
  const query = { accountId: ID, startDate: start, endDate: end, userId: user }
  return { type: FETCH_ADMIN_DETAILS, query }
}

/**
  * loadAdminDetails
  * @desc Load Admin Details Action Generator
  * @param {Object} data data to be loaded
  *@return {action} LoadAdminDetailsAction
*/
export function loadAdminDetails (data) {
  return { type: LOAD_ADMIN_DETAILS, data }
}

/**
  * loadUserDetails
  * @desc Load User Details Action Generator
  * @param {Object} data data to be loaded
  *@return {action} LoadUserDetailsAction
*/
export function loadUserDetails (data) {
  return { type: LOAD_USER_DETAILS, data }
}

/**
  * loadNotificationDetails
  * @desc Load Notification Details Action Generator
  * @param {Object} data data to be loaded
  *@return {action} LoadNotificationDetailsAction
*/
export function loadNotificationDetails (data) {
  return { type: LOAD_NOTIFICATION_DETAILS, data }
}

/**
 * loadNotificationUsers
 * @param {Object} data
 * @param {String} type
 * @return {action} loadNotificationUsersAction
 */
export function loadNotificationUsers (data, type) {
  return { type: LOAD_NOTIFICATION_USERS, data }
}

/**
  * loadContentDetails
  * @desc Load Content Details Action Generator
  * @param {Object} data data to be loaded
  *@return {action} LoadContentDetailsAction
*/
export function loadContentDetails (data) {
  return { type: LOAD_CONTENT_DETAILS, data }
}

/**
  * loadAlertDetails
  * @desc Load Content Details Action Generator
  * @param {Object} data data to be loaded
  *@return {action} LoadAlertDetailsAction
*/
export function loadAlertDetails (data) {
  return { type: LOAD_ALERT_DETAILS, data }
}

export function resetNoticationDetails () {
  return { type: RESET_NOTIFICATION_DETAILS }
}
